import React from 'react';
import PropTypes from 'prop-types';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import {reduxForm} from 'redux-form';
import Validation from 'infrastructure/js/components/controls/controlsValidations.js';
import Dialog from 'infrastructure/js/components/Dialog/dialog';
import InputSection from 'infrastructure/js/components/Dialog/InputSection/inputSection';
import EntitiesMultiSelect from '../../Common/Controls/EntitiesMultiSelect/entitiesMultiSelect.js';
import * as dialogHelper  from 'infrastructure/js/components/Dialog/dialogHelper';
import Dropdown from 'infrastructure/js/components/controls/Dropdown/dropdown';
import {enumTypes, getEnumLabel, getEnumValue} from '../../../utils/enumHelper';

import './editStatusDialog.scss';

class EditStatusDialog extends React.PureComponent {
  constructor(props) {
    super(props);

    this.dialogLabels = createLabelHelper('mat.dialog.');
    this.labels = createLabelHelper('mat.dialog.editStatus.');
    this.entitiesTypes = props.sData.get('entitiesTypes').toJS();
    this.isAutomateMode = props.sData.get('isAutomateMode');

    this.fetchConfig = {
      action: props.actions.fetchEntities,
      searchBy: {
        lot: [{
          objectName: 'excludeLotStatuses',
          values: [
            getEnumValue(enumTypes.LOT_STATUS)('UNDER_AUTOMATIC_INSPECTION'),
            getEnumValue(enumTypes.LOT_STATUS)('LOCKED_FOR_SHIPMENT'),
            getEnumValue(enumTypes.LOT_STATUS)('SHIPPED'),
          ]
        }]
      }
    };

    this.statuses = [
      {value: getEnumValue(enumTypes.LOT_STATUS)('IN_PREPARATION'), label: getEnumLabel(enumTypes.LOT_STATUS)('IN_PREPARATION')},
      {value: getEnumValue(enumTypes.LOT_STATUS)('READY_FOR_INSPECTION'), label: getEnumLabel(enumTypes.LOT_STATUS)('READY_FOR_INSPECTION')},
    ];
  }

  componentDidMount() {
    if (this.isAutomateMode) {
      const status = {value: getEnumValue(enumTypes.LOT_STATUS)('READY_FOR_INSPECTION'), label: getEnumLabel(enumTypes.LOT_STATUS)('READY_FOR_INSPECTION')}
      this.props.change('status', status);
    }
  }

  getDialogButtons() {
    let cancelTokenEnabled = !!this.props.sData.get('cancelToken') ;
    return {
      left: [{
        id:'cancel',
        text:   this.props.sData.get('loading') ? this.dialogLabels.get('stop') : this.dialogLabels.get('cancel'),
        action: this.props.sData.get('loading') ? this.onStop : this.onHide,
        enabledOnLoading: cancelTokenEnabled
      }],
      right: [
        {
          id:'submit',
          text: this.isAutomateMode ? this.dialogLabels.get('ok') : this.dialogLabels.get('edit'),
          bsStyle: 'primary',
          loading: this.props.sData.get('loading'),
          action: this.props.handleSubmit(this.onSubmit),
          disabled: this.props.sData.get('loading') ||
          this.props.sData.get('hasError') ||
          (this.props.sData.get('showIgnoreValidationCheckbox') && !this.props.sData.get('isIgnoreValidationWarnings'))
        }
      ]
    };
  }

  onSubmit = (data) => {
    let row = data['assets-multi-select'];
    let ids =  row?.assetsValue?.map(asset => asset.value) ?? [];

    let submitData = {
      lotsIds: ids,
      status: data.status?.value,
    }

    submitData.ignoreValidationWarnings = (this.props.sData.get('showIgnoreValidationCheckbox') && data.footerValidationCheckbox) ?
      data.footerValidationCheckbox : false;

    this.props.actions.submit(submitData, this.getMessageDialogBuilder(), this.props.reloadParentComponent, this.isAutomateMode);
  };

  getMessageDialogBuilder = () => {
    return (response, fnCloseDialog) => {
      let title = this.labels.get('confirmation.message.title', '', { count: response.totalJobItems});
      return dialogHelper.BuildDialogDescriptorForBO(response, fnCloseDialog, title);
    };
  };

  onHide =() => {
    this.props.actions.hide();
  };

  onStop =() => {
    this.props.actions.stop();
  };

  getFooterValidationCheckBox = () => {
    return this.props.sData.get('showIgnoreValidationCheckbox') ?
      {label: this.dialogLabels.get('ignorewarnings'),onChange: this.onFooterValidationChange} : null;
  };

  onFooterValidationChange = (value) => {
    this.props.actions.toggleIgnoreValidationWarningsCheckbox(value);
  };


  render() {

    return (
      <Dialog
        id="edit-status-dialog"
        className="edit-status-dialog"
        titleText={this.isAutomateMode ? this.labels.get('header.title.automate') : this.labels.get('header.title.edit') }
        show={this.props.sData.get('show')}
        onEntered={this.onEntered}
        onHide={this.onHide}
        sData={this.props.sData}
        footerValidationCheckbox={this.getFooterValidationCheckBox()}
        footerInformationIcon={dialogHelper.getFooterInformationIcon(this.props.sData, this.dialogLabels)}
        footerButtons={this.getDialogButtons()}
        onEnterKeyPress={this.props.handleSubmit(this.onSubmit)}
      >
        <InputSection label={this.labels.get('assets')} className="no-margin">
          <EntitiesMultiSelect
            id="assets-multi-select"
            name="assets-multi-select"
            entitiesTypes={this.entitiesTypes}
            validate={Validation.required}
            preSelectedEntities={ this.props.sData.get('preselectedAssets')}
            fetchConfig={this.fetchConfig}
            autoFocus={true}
            { ...this.props }
            isDisabled={this.isAutomateMode}
            // onValueChangeCallback = {this.onPreselectedAssetsChange}
          />
        </InputSection>

        <InputSection label={this.labels.get('status')} htmlFor="status" className="">
          <Dropdown id="status-dropdown" name="status"
                    // placeholder={this.labels.get('substatus.placeholder')}
                    validate={Validation.dropdown.required}
                    isDisabled={this.isAutomateMode}
                    options={this.statuses}/>
        </InputSection>

      </Dialog>
    );
  }
}

export default reduxForm({
    form: 'editStatusDialog',
    onChange:  (values, dispatch, props, previousValues ) => {
      dialogHelper.onFormChangeHandler(values, props, previousValues);
    },
  }
)(EditStatusDialog);


EditStatusDialog.defaultProps = {
  preselectedAssets: [],
};
EditStatusDialog.propTypes = {
  actions : PropTypes.object.isRequired,
  sData : PropTypes.object.isRequired,
};
